export default __webpack_public_path__ + "static/shop-image8-0d8b23a0b74bb956322e0f88d113d55c.jpg";